module.exports = __webpack_public_path__ + "img/apl-2SM.4e569480.jpg";